import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";

const navbar = props => (
  <div className="Navbar">
    <div>
      <img src="/img/main-top.png" className="Top" />
      <div className="Video-button-container">
        <img src="/img/video-button.png" className="Video-button" />
      </div>
    </div>
  </div>
);

export default navbar;
